import styled from 'styled-components';

// Components
import { Typography } from '../../../display/Typography';
import ModalContainer from '../../containers/ModalContainer';

export const ModalContainerStyled = styled(ModalContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Container = styled.div<{ isLoading?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 1rem 2rem 2rem;
  opacity: ${({ isLoading }) => (isLoading ? 0.5 : 1)};
`;

export const ContainerLoader = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
`;

export const Icon = styled.img<{ isLoading?: boolean }>`
  width: 8rem;
  height: 8rem;
  margin-bottom: 2rem;
  opacity: ${({ isLoading }) => (isLoading ? 0.5 : 1)};
`;

export const Title = styled(Typography)`
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.8rem;
  max-width: 90%;
`;

export const TeamName = styled(Typography)`
  color: ${({ theme }) => theme.colors.primary};
  background-color: ${({ theme }) => theme.colors.greyLight};
  padding: 1rem 2rem;
  border-radius: 0.5rem;
  font-size: 1.8rem;
  text-align: center;
  max-width: 90%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  width: 100%;
  justify-content: center;
  margin-top: 1rem;

  > button {
    min-width: 12rem;
  }

  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column-reverse;
  }
`;
